import React, { useState, useEffect } from 'react';
import EditModalWrapper from './EditModalWrapper';

const COUNTRIES = [
    { name: 'India', code: 'IN' },
    { name: 'Germany', code: 'DE' },
    { name: 'United States', code: 'US' },
    { name: 'United Kingdom', code: 'GB' },
    { name: 'United Arab Emirates', code: 'AE' },
    { name: 'Saudi Arabia', code: 'SA' },
    { name: 'Qatar', code: 'QA' },
    { name: 'Kuwait', code: 'KW' },
    { name: 'Oman', code: 'OM' },
    { name: 'Bahrain', code: 'BH' },
    { name: 'Canada', code: 'CA' },
    { name: 'Australia', code: 'AU' },
    { name: 'France', code: 'FR' },
    { name: 'Italy', code: 'IT' },
    { name: 'Spain', code: 'ES' },
    { name: 'Netherlands', code: 'NL' },
    { name: 'Belgium', code: 'BE' },
    { name: 'Switzerland', code: 'CH' },
    { name: 'Austria', code: 'AT' },
    { name: 'Poland', code: 'PL' },
    { name: 'Portugal', code: 'PT' },
    { name: 'Ireland', code: 'IE' },
    { name: 'Sweden', code: 'SE' },
    { name: 'Norway', code: 'NO' },
    { name: 'Denmark', code: 'DK' },
    { name: 'Finland', code: 'FI' },
];

const EditNationalityModal = ({ isOpen, onClose, userData, onSave }) => {
    const [form, setForm] = useState({
        country: 'India',
        identificationNumber: '',
    });

    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setForm({
                country: userData?.nationality || userData?.nationality_country || 'India',
                identificationNumber: userData?.identification_number || userData?.passport_number || '',
            });
        }
    }, [isOpen, userData]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.country) {
            alert('Country is required');
            return;
        }

        setIsSubmitting(true);
        try {
            const formData = new FormData();
            formData.append('nationality', form.country);
            formData.append('identification_number', form.identificationNumber);

            await onSave(formData);
            onClose();
        } catch (error) {
            console.error('Error saving nationality:', error);
            alert('Failed to save changes. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <EditModalWrapper
            isOpen={isOpen}
            onClose={onClose}
            title="Edit Nationality"
            onSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            size="sm"
        >
            <div className="space-y-5">
                {/* Country */}
                <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1.5">
                        Country <span className="text-red-500">*</span>
                    </label>
                    <select
                        value={form.country}
                        onChange={(e) => setForm({ ...form, country: e.target.value })}
                        className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition-all bg-white text-slate-900"
                        required
                    >
                        <option value="">Select country</option>
                        {COUNTRIES.map((c) => (
                            <option key={c.code} value={c.name}>{c.name}</option>
                        ))}
                    </select>
                </div>

                {/* Identification Number */}
                <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1.5">
                        Identification Number
                    </label>
                    <input
                        type="text"
                        value={form.identificationNumber}
                        onChange={(e) => setForm({ ...form, identificationNumber: e.target.value })}
                        className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition-all text-slate-900"
                        placeholder="e.g., W3562952"
                    />
                </div>
            </div>
        </EditModalWrapper>
    );
};

export default EditNationalityModal;
